// import { tokenRefreshInterceptor } from "@babackapp/auth-client/utils";
import createFetchClient from "openapi-fetch";
import createClient from "openapi-react-query";
import type { paths } from "./schema";

console.log({ baseUrl: import.meta.env.VITE_API_URL });

const fetchClient = createFetchClient<paths>({
  baseUrl: import.meta.env.VITE_API_URL,
  credentials: "include",
  // @ts-expect-error type mismatch
  fetch: (...args) => window.interceptedFetch?.(...args) || fetch(...args),
});

export const $api = createClient(fetchClient);

export { fetchClient };
